
import DateHelper from "../helpers/DateHelper";

export default
    class ServiceController {
    constructor(resource) {
        this._resource = resource
    }

    async getServices(beginDate, endDate) {
        let response = null
        try {
            let result = await this._resource(`services/client`).get({ datas: { beginDate, endDate } })
            response = {
                ok: result.ok,
                data: result.body.map(i => {
                    return {
                        vehicle_request_id: i.id,
                        vehicle_request_checkin: i.data_checkin,
                        vehicle_request_checkout: i.data_checkout,
                        vehicle_request_nome: i.nome,
                        vehicle_request_vehicle: i.vehicle,
                        vehicle_request_duracao: i.duracao,
                        vehicle_request_client: i.client,
                        vehicle_request_valor_reserva: i.valor_da_reserva,
                        vehicle_request_valor_multa: i.valor_da_multa,
                        vehicle_request_valor_total:i.valor_total

                    }
                })
            }
        } catch (error) {

            response = {
                ok: false,
                message: error.body.message
            }
        }
        return response
    }
}